import axios from "axios";

const store = {
  state: {
    categories: [],
  },

  getters: {
    getCategory(state) {
      return state.categories;
    },
  },

  mutations: {
    loadCategoriesMutation(state, categories) {
      state.categories = categories;
    },

    addCategoryMutation(state, category) {
      state.categories.push(category);
    },

    setCategoryMutation(state, category) {
      let index = state.categories.findIndex((c) => c.id == category.id);
      state.categories.splice(index, 1, category);
    },

    deleteCategoryMutation(state, categoryId) {
      let index = state.categories.findIndex((c) => c.id == categoryId);
      state.categories.splice(index, 1);
    },
  },

  actions: {
    indexCategoriesAction({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/category`)
          .then((res) => {
            commit("loadCategoriesMutation", res.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    storeCategoryAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/category/store`, payload)
          .then((res) => {
            commit("addCategoryMutation", res.data.category);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    updateCategoryAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/category/update/${payload.id}`, payload)
          .then((res) => {
            commit("setCategoryMutation", res.data.category);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    deleteCategoryAction({ commit, rootState }, categoryId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/category/delete/${categoryId}`)
          .then(() => {
            commit("deleteCategoryMutation", categoryId);
            rootState[6].notes = [];
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};

export default store;
